export default "__VITE_ASSET__CRcbOU9k__"